import { createContext } from 'react'

import { SpotlightCTABannerSession } from 'interfaces/types'

export type CtaBannerContextType = { data: SpotlightCTABannerSession }

export const CtaBannerContext = createContext<CtaBannerContextType>(
  {} as CtaBannerContextType,
)
